import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import Menu from "../S1_Header/menu";

import S6_Footer from "../S6_Footer";

const CustomGrid = styled(Grid)`
  background-image: url("/images/purplebg.png");
  background-size: cover;
  padding: 100px 0;
  background-position: center;
  @media screen and (max-width: 599px) {
    padding: 46px 0;
  }
`;
const CustomGrids = styled(Grid)`
  padding: 100px 0;
  /* background-position; */
`;
const GridContainer = styled(Grid)`
  /* padding: 100px 0; */
  /* background-image: url("/images/purplebg.png");
  background-size: cover; */
  /* background-position; */
`;
const Cells = styled.div`
  min-height: 100vh;
  /* display: flex;
  align-items: center;
  place-content: center; */
`;

const VideoBK = styled.video`
  height: auto;
  display: block;
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;
const Wrapper = styled.div`
  background: rgb(0 0 0 / 5%);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1;
`;

const index = () => {
  return (
    <div>
      <VideoBK autoPlay loop muted>
        <source src="/images/hapebg.mp4" type="video/mp4" />
      </VideoBK>
      <Menu />
      <Wrapper>
        <SectionWrapper pt="0px" id="explore" pb650px="10px">
          <Container>
            <SectionSmallHeading p="130px 0 0 0">
              Tokenomics
            </SectionSmallHeading>
            <SectionHeading>TOKEN DETAIL</SectionHeading>
            <SectionSubHeading p="2px 0" fs="18px">
              Ticker: $Hape
            </SectionSubHeading>
            <SectionSubHeading p="2px 0" fs="18px">
              Total Supply: 1 Billion
            </SectionSubHeading>
            <SectionSubHeading p="2px 0" fs="18px">
              Taxes: 3/5%
            </SectionSubHeading>
            <SectionSubHeading p="2px 0" fs="18px">
              Max Buy: 1%
            </SectionSubHeading>

            <SectionSubHeading p="2px 0" fs="18px">
              Max Wallet: 2%
            </SectionSubHeading>

            <SectionSubHeading p="16px 0 0 0" fs="18px">
              contract: 0xe36ac872eb1aefcf746feb6728b81b38fc6d75b2
            </SectionSubHeading>
          </Container>
        </SectionWrapper>
        <S6_Footer />
      </Wrapper>
    </div>
  );
};

export default index;
